/* eslint-disable array-callback-return */
import { toMoney } from "./formatter";
import { GetHeaders } from "./getHeaders";
import { getRowDetail } from "./getRowDetail";
import { useSelector } from "react-redux";
export const GetRow = (row, columns, transposed, week) => {
  let valuesToTable = [];
  let subTotalToTable = [];
  let totalToTable = [];
  let inValue = [];
  let totalInValue = [];
  let netInFlow = [];
  let outValue = [];
  let totalOutValue = [];
  let initialBalance = [];
  let totalInOut;
  let { cashFlowCategories, cashFlowAreas } = useSelector(
    (state) => state.flujocaja
  );

  cashFlowCategories = cashFlowCategories
    ? Object.values(cashFlowCategories)
    : [];
  cashFlowAreas = Object.values(cashFlowAreas);
  if (row) {
    const finalSalesRow = transposed.find(f => f.tag === "OTHER_INCOME")
    const finalSalesRowIndex = transposed.indexOf(finalSalesRow)

    transposed?.map((element, index) => {
      if (
        element.tag === "Credit clients" ||
        element.tag === "Sales projection" ||
        element.tag === "Partner lending" ||
        element.tag === "Pending checks" ||
        element.tag === "Other incomes" ||
        element.tag === "Trade agreements" ||
        element.tag === "Financial Instruments" ||
        element.tag === "Transbank" ||
        element.tag === "Factoring" || 
        index <= finalSalesRowIndex
      ) {
        const values = getRowDetail(element, columns, week);

        const area = cashFlowAreas?.find((area) => area.name === element.tag);
        
        inValue.push({
          title: GetHeaders(element.tag),
          name: GetHeaders(element.tag),
          category: area ? area?.category: element?.tag,
          values: values?.amount,
          total: element.total ? toMoney(Math.round(element.total)) : "-",
          cashflowAreaId: element.cashflowAreaId,
          startDate: row?.startDate,
          endDate: row?.endDate,
          useDelayesd: row?.monthObject?.delayedAreas,
          weekEndDate: values?.weekEndDate,
          weekStartDate: values?.weekStartDate,
        });
      } else if (
        element.tag !== "netInflow" &&
        element.tag !== "initialBalance" &&
        element.tag !== "closingBalance" &&
        element.tag !== "Financial Instruments" &&
        element.tag !== "Trade agreements" &&
        element.tag !== "inflows" &&
        element.tag !== "outflows"
      ) {
        const area = cashFlowAreas?.find((area) => area.name === element.tag);

        const category = cashFlowCategories?.find(
          (category) =>
            category?.category === (area ? area.category : element.tag)
        );
        const values = getRowDetail(element, columns, week);
        const title = area
          ? element.tag
          : category
          ? category.name
          : element.tag;
        const detail = {
          title: GetHeaders(element.tag),
          name: GetHeaders(title),
          category: area ? area?.category: element?.tag,
          values: values?.amount,
          total: element.total ? toMoney(Math.round(element.total)) : "-",
          cashflowAreaId: element.cashflowAreaId,
          startDate: row?.startDate,
          endDate: row?.endDate,
          useDelayesd: row?.monthObject?.delayedAreas,
          weekEndDate: values?.weekEndDate,
          weekStartDate: values?.weekStartDate,
        };
        if (
          !["TOTAL_INCOME", "OTHER_INCOME"].includes(element.tag) &&
          (!category || !category.isIncome)
        ) {
          outValue.push(detail);
        } else {
          inValue.push(detail);
        }
      }
      if (element.tag === "inflows") {
        const values = getRowDetail(element, columns, week);
        totalInValue.push({
          values: values?.amount,
          title: GetHeaders(element.tag),
          name: GetHeaders(element.tag),
          total: element.total ? toMoney(Math.round(element.total)) : "-",
        });
      }
      if (element.tag === "outflows") {
        const values = getRowDetail(element, columns, week);
        totalOutValue.push({
          values: values?.amount,
          title: GetHeaders(element.tag),
          name: GetHeaders(element.tag),
          total: element.total ? toMoney(Math.round(element.total)) : "-",
        });
      }
      if (element.tag === "netInflow") {
        const values = getRowDetail(element, columns, week);
        netInFlow.push({
          title: GetHeaders(element.tag),
          name: GetHeaders(element.tag),
          values: values?.amount,
          total: element.total ? toMoney(Math.round(element.total)) : "-",
        });
      }
      if (element.tag === "initialBalance") {
        const values = getRowDetail(element, columns, week);
        initialBalance.push({
          title: GetHeaders(element.tag),
          name: GetHeaders(element.tag),
          values: values?.amount,
          total: "-",
        });
      }
      if (element.tag === "closingBalance") {
        const values = getRowDetail(element, columns, week);
        totalInOut = {
          title: GetHeaders(element.tag),
          name: GetHeaders(element.tag),
          values: values?.amount,
          total: element.total ? toMoney(Math.round(element.total)) : "-",
        };
      }
    });
  }

  valuesToTable.push(
    { amount: inValue, total: totalInValue },
    { amount: outValue, total: totalOutValue }
  );

  subTotalToTable.push(
    { amount: netInFlow, total: 0 },
    { amount: initialBalance, total: 0 }
  );

  totalToTable.push({ amount: totalInOut });
  return { valuesToTable, subTotalToTable, totalToTable };
};

export const forms = {
  flujocaja: {
    title: "Agregar fuente de datos",
    forms: [
      {
        type: "subtitleTop",
        name: "Crear fuentes de Ingreso / Egreso",
        showFilters: false,
      },
      {
        type: "name",
        label: "Ingreso / Egreso",
        id: "nombre",
        placeholder: "Nombre",
      },
      {
        type: "select",
        label: "Tipo",
        id: "tipo",
        options: [
          { option: "Seleccionar", values: "" },
          { option: "Entrada única", values: "singleEntry" },
          { option: "Entrada recurrente", values: "recurrent" },
          { option: "Saldo inicial", values: "initialBalance" },
          { option: "Créditos", values: "credits" },
        ],
        values: ["", "singleEntry", "recurrent", "initialBalance", "credits"],
      },
      {
        type: "textarea",
        label: "Descripción",
        id: "comentario",
        placeholder: "Descripción",
      },
      { type: "subtitle", name: "Detalle", showFilters: false },
      {
        type: "creditType",
        label: "Tipo de crédito",
        id: "creditType",
        options: [
          { option: "Comercial", value: "comercial" },
          { option: "Bullet", value: "bullet" },
          { option: "Comex", value: "comex" },
          { option: "Carta de Crédito", value: "cartaCredito" },
          { option: "Leasing", value: "leasing"}
        ],
      },
      {
        type: "banks",
        label: "Banco",
        id: "banks",
        options: [
          {
            value: "bankBBVA",
            name: "Banco BBVA",
          },
          {
            value: "bci",
            name: "Banco BCI",
          },
          {
            value: "bankBICE",
            name: "Banco BICE",
          },
          {
            value: "bankChile",
            name: "Banco Chile",
          },
          {
            value: "bankChile2",
            name: "Banco de Chile",
          },
          {
            value: "bankEstado",
            name: "Banco Estado",
          },
          {
            value: "bankItau",
            name: "Banco ITAU",
          },
          {
            value: "santander",
            name: "Banco Santander",
          },
          {
            value: "security",
            name: "Banco Security",
          },
          {
            value: "falabella",
            name: "Banco Falabella",
          },
          {
            value: "scotiabank",
            name: "Banco Scotiabank",
          },
          {
            value: "internacional",
            name: "Banco Internacional",
          },
          {
            value: "ripley",
            name: "Banco Ripley",
          },
          {
            value: "corpbanca",
            name: "Banco CORPBANCA",
          },
          {
            value: "consorcio",
            name: "Banco Consorcio",
          },
          {
            value: "coopeuch",
            name: "Banco Coopeuch",
          },
        ],
      },
      {
        type: "identificator",
        label: "Identificador",
        placeholder: "Identificador del crédito",
        id: "identificator",
      },
      {
        type: "area",
        label: "Área",
        id: "area",
        placeholder: "Área",
      },
      {
        type: "repeat",
        label: "Repetir",
        id: "repeat",
        options: [
          { option: "Seleccione repetición", values: "" },
          { option: "Cada 7 días", values: 7 },
          { option: "Cada 15 días", values: 15 },
          { option: "Cada 30 días", values: 30 },
          { option: "Cada 45 días", values: 45 },
          { option: "Cada 60 días", values: 60 },
          { option: "Cada 90 días", values: 90 },
        ],
      },
      {
        type: "pay",
        label: "Pago",
        id: "pay",
        options: [
          { option: "Por Fecha", values: "2" },
          { option: "Primer día hábil", values: "1" },
          { option: "Quinto día hábil", values: "5" },
          { option: "Último día hábil", values: "30" },
        ],
      },
      {
        type: "amount",
        label: "Monto ($)",
        id: "monto",
        placeholder: "Monto",
      },
      {
        type: "paymentsAmount",
        label: "Monto cuota",
        id: "paymentsAmount",
        placeholder: "Monto de la cuota",
      },
      {
        type: "payments",
        label: "Cuotas",
        id: "payments",
        placeholder: "Número de cuotas",
      },
      {
        type: "fees",
        label: "Tasa",
        id: "fees",
        placeholder: "0.5%",
      },
      {
        type: "feesPeriod",
        label: "Período Tasa",
        id: "feesPeriod",
        options: [
          { value: "mensual", name: "Mensual" },
          { value: "anual", name: "Anual" },
        ],
      },
      {
        type: "date",
        label: "Fecha",
        id: "date",
      },
      {
        type: "finalDate",
        label: "Hasta",
        id: "finalDate",
      },
      {
        type: "currency",
        label: "Moneda",
        id: "moneda",
        options: [{ option: "CLP", values: "CLP" }],
      },
    ],
  },
  conexiones: {
    title: "Nueva contraseña",
    forms: [
      { type: "subtitle", name: "Datos del contacto", showFilters: false },
      {
        type: "input",
        label: "Nombre*",
        id: "nombre",
        placeholder: "Entrada única",
      },
      {
        type: "input",
        label: "Tipo*",
        id: "tipo",
        placeholder: "Entrada única",
      },
      {
        type: "multiselect",
        label: "Roles*",
        id: "multiselect",
        options: [{ name: "admin", id: 1 }],
      },
    ],
  },
  proveedores: {
    title: "Proveedores Excluidos",
    forms: [
      { type: "subtitle", name: "Resumen", showFilters: false },
      {
        type: "input",
        label: "RUT*",
        id: "rut",
        placeholder: "Entrada única",
      },
      {
        type: "input",
        label: "Nombre*",
        id: "nombre",
        placeholder: "Entrada única",
      },
      {
        type: "multiple",
        values: [
          {
            type: "input",
            label: "Total*",
            id: "total1",
            placeholder: "Entrada única",
          },
          {
            type: "input",
            label: "Total*",
            id: "total2",
            placeholder: "Entrada única",
          },
        ],
      },
      {
        type: "input",
        label: "Total",
        id: "total",
        placeholder: "Entrada única",
      },
      {
        type: "select",
        label: "Pagar con banco",
        id: "pagarconbanco",
        options: ["Seleccionar"],
      },
      { type: "button", label: "Informar" },
      { type: "subtitle", name: "Pagos adicionales", showFilters: false },
      {
        type: "input",
        label: "RUT*",
        id: "rutpagosadicionales",
        placeholder: "Entrada única",
      },
      {
        type: "input",
        label: "Nombre*",
        id: "nombrepagosadicionales",
        placeholder: "Entrada única",
      },
      {
        type: "multiple",
        values: [
          {
            type: "input",
            label: "Tipo de documento",
            id: "tipodedocumento",
            placeholder: "Entrada única",
          },
          {
            type: "input",
            label: "Detalle",
            id: "detalle",
            placeholder: "Entrada única",
          },
        ],
      },
      {
        type: "multiple",
        values: [
          {
            type: "input",
            label: "Moneda",
            id: "moneda",
            placeholder: "Entrada única",
          },
          {
            type: "input",
            label: "A pagar",
            id: "apagar",
            placeholder: "Entrada única",
          },
        ],
      },
    ],
  },
  documentostributarios: {
    title: "Filtrar",
    forms: [
      { type: "subtitle", name: "Proveedor", showFilters: true },
      { type: "input", label: "RUT*", id: "rut", placeholder: "Entrada única" },
      { type: "subtitle", name: "Documentos", showFilters: false },
      {
        type: "input",
        label: "Folio",
        id: "folio",
        placeholder: "Entrada única",
      },
      {
        type: "multiple",
        values: [
          {
            type: "input",
            label: "Monto Mínimo",
            id: "montominimo",
            placeholder: "Entrada única",
          },
          {
            type: "input",
            label: "Monto Máximo",
            id: "montomaximo",
            placeholder: "Entrada única",
          },
        ],
      },
      { type: "subtitle", name: "Fechas", showFilters: false },
      {
        type: "multiple",
        values: [
          {
            type: "input",
            label: "Fecha inicial",
            id: "fechainicial",
            placeholder: "Entrada única",
          },
          {
            type: "input",
            label: "Fecha final",
            id: "fechafinal",
            placeholder: "Entrada única",
          },
        ],
      },
      { type: "subtitle", name: "Estado", showFilters: false },
      {
        type: "select",
        label: "Estado",
        id: "estado",
        options: ["Seleccionar"],
      },
    ],
  },
  agenda: {
    title: "Nuevo cliente",
    forms: [
      { type: "subtitle", name: "Datos del contacto" },
      { type: "input", label: "RUT*", id: "rut", placeholder: "Entrada única" },
      {
        type: "input",
        label: "Nombre",
        id: "nombre",
        placeholder: "Entrada única",
      },
      {
        type: "input",
        label: "Email",
        id: "email",
        placeholder: "Entrada única",
      },
      { type: "select", label: "Tipo", id: "tipo", options: ["Seleccionar"] },
      {
        type: "select",
        label: "Área de flujo de caja",
        id: "area",
        options: ["Seleccionar"],
      },
      { type: "subtitle", name: "Datos tributarios" },
      {
        type: "input",
        label: "Dirección",
        id: "direccion",
        placeholder: "Entrada única",
      },
      {
        type: "input",
        label: "Días de pago",
        id: "diasdepago",
        placeholder: "Entrada única",
      },
      {
        type: "input",
        label: "Giro comercial",
        id: "girocomercial",
        placeholder: "Entrada única",
      },
      { type: "subtitle", name: "Datos tributarios" },
      { type: "select", label: "Banco", id: "banco", options: ["Seleccionar"] },
      {
        type: "input",
        label: "Tipo de cuenta",
        id: "tipocuenta",
        placeholder: "Entrada única",
      },
    ],
  },
  creditos: {
    title: "Nuevo Crédito",
    forms: [
      {
        type: "subtitle",
        name: "Datos",
      },
      {
        type: "select",
        label: "Tipo de Crédito",
        id: "tipo",
        options: ["Seleccionar"],
      },
      {
        type: "select",
        label: "Banco",
        id: "banco",
        options: ["Seleccionar"],
      },
      {
        type: "input",
        label: "Identificador*",
        id: "identificador",
        placeholder: "Entrada única",
      },
      {
        type: "multiple",
        values: [
          {
            type: "input",
            label: "Monto Liquido*",
            id: "montoliquido",
            placeholder: "Entrada única",
          },
          {
            type: "select",
            label: "Moneda",
            id: "moneda",
            options: ["Seleccionar"],
          },
        ],
      },
      {
        type: "multiple",
        values: [
          {
            type: "input",
            label: "Monto Cuota*",
            id: "montocuota",
            placeholder: "Entrada única",
          },
          {
            type: "input",
            label: "Cuotas",
            id: "cuotas",
            placeholder: "Entrada única",
          },
        ],
      },
      {
        type: "multiple",
        values: [
          {
            type: "input",
            label: "Tasa (%)",
            id: "tasa",
            placeholder: "Entrada única",
          },
          {
            type: "select",
            label: "Periódo Tasa",
            id: "periodo",
            options: ["Seleccionar"],
          },
        ],
      },
      {
        type: "multiple",
        values: [
          {
            type: "input",
            label: "Fecha Emisión",
            id: "fechaemision",
            placeholder: "Entrada única",
          },
          {
            type: "input",
            label: "Primer Vencimiento*",
            id: "primervencimiento",
            placeholder: "Entrada única",
          },
        ],
      },
    ],
  },
};

export const NotClickable = () => {
  const { cashFlowCategories } = useSelector((state) => state.flujocaja);
  const notClickable = [
    "Ingresos totales",
    "Gastos RRHH",
    "Proveedores por pagar",
    "Financiamiento",
    //"Importaciones e impuestos",
    "Importaciones",
    "Impuestos",
    "Egresos totales",
    "Otros Ingresos",
  ];
  const notClickableAreas = cashFlowCategories
    ? [
        ...notClickable,
        ...Object?.values(cashFlowCategories)?.map(
          (category) => category?.category
        ),
      ]
    : [];
  return notClickableAreas;
};

export const FlowLVLabel = {
  INCOME: 'Ingresos',
  EXPENSE: 'Egresos'
}

export const FlowLVL = {
  INCOME: 'INCOME',
  EXPENSE: 'EXPENSE'
}